import React, { Component, createRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import ValidationText from '../../utils/validation/ValidationText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faFileAlt, faCheckCircle, faFilePdf, faFileWord, faFile } from '@fortawesome/free-solid-svg-icons';
import { APIURL, GetPreviewForApproval, GetUploadedFiles } from '../../services/axiosServices/ApiEndPoints';
import { WebToken } from '../../utils/AppSetting';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import SwalServices from '../../services/swalServices/SwalServices';

export default class ApproveTimesheetExpense extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.sigCanvas = createRef();
        this.state = {
            submissionId: null,
            selectedImage: null,
            showImageModal: false,
            previewPdfUrl: null,
            uploadedFiles: [],
            approverDetails: {
                pdfUrl: null,
                approverName: '',
                date: '',
                signature: ''
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                approverName: [
                    { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "Approver Full Name") },
                    { type: "maxLength", maxLength: 100, message: "Maximum length is 100" },
                    { type: "minLength", minLength: 2, message: "Minimum length is 2" }
                ],
                date: [
                    { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "Date") }
                ],
                signature: [
                    { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "Signature") }
                ],
                pdfUrl: [
                    { type: "require", message: CommonValidationMessages.FieldRequired.replace("{0}", "Preview Form") }
                ]
            },
            isLoading: false,
            showPreviewModal: false
        };
    }

    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let submissionId = params.get("")
        this.setState({ submissionId: submissionId });
        this.handlePreviewPDF(submissionId);
        this.fetchUploadedFiles(submissionId);
    }

    handlePreviewPDF = async (submissionId) => {
        this.setState({ isLoading: true });
        try {
            const response = await fetch(`${APIURL}${GetPreviewForApproval}/${submissionId}`, {
                headers: { 'Authorization': `Bearer ${WebToken}` }
            });
            if (response.ok) {
                const blob = await response.blob();
                const fileURL = URL.createObjectURL(blob);
                this.setState(prevState => ({
                    approverDetails: { ...prevState.approverDetails, pdfUrl: fileURL },
                    isLoading: false,
                }));
                setTimeout(() => {
                    this.previewForm();
                }, 1000);
            } else {
                this.swalServices.Error('File not found');
                this.setState({ isLoading: false });
            }
        } catch (err) {
            console.error('Error opening PDF', err);
            this.swalServices.Error('Could not load the preview file.');
            this.setState({ isLoading: false });
        }
    };

    fetchUploadedFiles = async (submissionId) => {
        try {
            const response = await fetch(`${APIURL}${GetUploadedFiles}/${submissionId}`, {
                headers: { 'Authorization': `Bearer ${WebToken}` }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success === 1) {
                    this.setState({ uploadedFiles: data.data });
                } else {
                    this.swalServices.Error(data.msg);
                }
            }
        } catch (err) {
            console.error("Error loading uploaded files:", err);
            this.swalServices.Error('Failed to load attachments.');
        }
    };

    handleChange = (event, name) => {
        const value = event.target.value;
        this.setState(prevState => ({
            approverDetails: { ...prevState.approverDetails, [name]: value }
        }));
    };

    handleSignatureEnd = () => {
        if (this.sigCanvas.current?.getCanvas) {
            const dataUrl = this.sigCanvas.current.getCanvas().toDataURL('image/png');
            this.setState(prevState => ({
                approverDetails: { ...prevState.approverDetails, signature: dataUrl }
            }));
        }
    };

    clearSignature = () => {
        this.sigCanvas.current?.clear();
        this.setState(prevState => ({
            approverDetails: { ...prevState.approverDetails, signature: '' }
        }));
    };

    previewForm = () => {
        if (this.state.approverDetails.pdfUrl) {
            this.setState({ showPreviewModal: true });
        } else {
            this.swalServices.Error('The document is not available for preview.');
        }
    };
    closePreviewModal = () => {
        this.setState({ showPreviewModal: false });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.approverDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    approveForm = (submissionId) => {
        if (submissionId.length === 0) {
            this.swalServices.Error('Invalid Form');
            return;
        }
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            // this.swalServices.Confirm(
            //     'Confirm Approval',
            //     'Are you sure you want to approve this timesheet?',
            //     CommonSuccessMessages.Yes_Text,
            //     CommonSuccessMessages.No_Text
            // ).then(response => {
            //     if (response === true) {
            this.setState({ isLoading: true });
            const { approverName, date, signature } = this.state.approverDetails;
            const request = { approverName, approvalDate: date, approverSign: signature };

            this.adminServices.approveForm(request, submissionId).then(response => {
                if (response.success === 1) {
                    this.swalServices.Success(response.msg);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    this.swalServices.Error(response.msg);
                }
                this.setState({ isLoading: false });
            }).catch(error => {
                console.error("Approval Error:", error);
                this.swalServices.Error("An unexpected error occurred.");
                this.setState({ isLoading: false });
            });
            // }
            // });
        }
    }

    openImagePreview = (file) => {
        const isPdf = file.path.toLowerCase().endsWith('.pdf');
        if (isPdf) {
            this.setState({
                previewPdfUrl: file.path,
                showPreviewModal: true
            });
        } else {
            this.setState({
                selectedImage: file.path,
                showImageModal: true
            });
        }
    };

    previewForm = () => {
        if (this.state.approverDetails.pdfUrl) {
            this.setState({
                previewPdfUrl: this.state.approverDetails.pdfUrl,  // 👈 Load submission PDF only here
                showPreviewModal: true
            });
        } else {
            this.swalServices.Error('The document is not available for preview.');
        }
    };

    closeImagePreview = () => {
        this.setState({ showImageModal: false, selectedImage: null });
    };

    closePreviewModal = () => {
        this.setState({ showPreviewModal: false, previewPdfUrl: null });
    };

    render() {

        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
                <div className="w-full max-w-6xl mx-auto lg:grid lg:grid-cols-2 shadow-2xl rounded-xl overflow-hidden">

                    <div className="aprrove-content bg-gradient-to-br from-gray-800 to-gray-900 text-white p-10 flex flex-col justify-between">
                        <div className='approve-text'>
                            <img className="w-40 mb-8 ahg-logo" src="AHG-logo.svg" alt="Arbour Health Group" />
                            <h1 className="text-4xl text-gray-800 font-semibold leading-tight mb-4 page-heading">Form Approval</h1>
                            <p className="text-gray-500 text-lg heading-para">
                                Please review the submitted form details carefully. Your approval is required to proceed.
                            </p>
                            <div className="mt-10 view-btn">
                                <button
                                    onClick={this.previewForm}
                                    disabled={!this.state.approverDetails.pdfUrl || this.state.isLoading}
                                    className="w-fit bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex items-center justify-center border-0"
                                >
                                    <FontAwesomeIcon icon={faFileAlt} className="mr-3" />
                                    View Submitted Form
                                </button>
                            </div>
                            {this.state.uploadedFiles?.length > 0 && (
                                <div className="mt-10">
                                    <h3 className="text-xl font-semibold text-gray-700 mb-4">Attached Files</h3>
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
                                        {this.state.uploadedFiles.map((file, index) => {
                                            const filePath = file.path.toLowerCase();
                                            const isPdf = filePath.endsWith('.pdf');
                                            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
                                            const isWord = /\.(doc|docx)$/i.test(filePath);

                                            let content;
                                            if (isPdf) {
                                                content = (
                                                    <div className="w-20 h-20 bg-gray-100 border flex items-center justify-center rounded shadow-md">
                                                        <FontAwesomeIcon icon={faFilePdf} className="text-red-600 text-3xl" />
                                                    </div>
                                                );
                                            } else if (isWord) {
                                                content = (
                                                    <div className="w-20 h-20 bg-gray-100 border flex items-center justify-center rounded shadow-md">
                                                        <FontAwesomeIcon icon={faFileWord} className="text-blue-600 text-3xl" />
                                                    </div>
                                                );
                                            } else if (isImage) {
                                                content = (
                                                    <img
                                                        src={file.path}
                                                        alt={file.filename || `uploaded-${index}`}
                                                        className="w-20 h-20 object-cover rounded shadow-md border border-gray-300"
                                                    />
                                                );
                                            } else {
                                                // Generic file icon
                                                content = (
                                                    <div className="w-20 h-20 bg-gray-100 border flex items-center justify-center rounded shadow-md">
                                                        <FontAwesomeIcon icon={faFile} className="text-gray-600 text-3xl" />
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div
                                                    key={index}
                                                    className="cursor-pointer hover:scale-105 transition-transform"
                                                    onClick={() => this.openImagePreview(file)}
                                                >
                                                    {content}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                        </div>
                        <div className="text-center text-gray-500 text-sm mt-12">
                            <p>&copy; {new Date().getFullYear()} Arbour Healthcare Group. All Rights Reserved.</p>
                        </div>
                    </div>

                    <div className="bg-white p-10 approval-form">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-8 mt-0">Approval Details</h2>
                        <div className="space-y-5">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Approver Name<span className="text-red-500">*</span></label>
                                <input
                                    className="input input-bordered w-full p-3 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition"
                                    type="text"
                                    id='approverName'
                                    name='approverName'
                                    value={this.state.approverDetails.approverName}
                                    onChange={(e) => this.handleChange(e, 'approverName')}
                                    placeholder="Enter your full name"
                                />
                                <ValidationText error={this.state.validState.error.approverName} className="text-[14px]" />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Date<span className="text-red-500">*</span></label>
                                <input
                                    className="input input-bordered w-full p-3 border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 transition"
                                    type="date"
                                    id='date'
                                    name='date'
                                    value={this.state.approverDetails.date}
                                    onChange={(e) => this.handleChange(e, 'date')}
                                />
                                <ValidationText error={this.state.validState.error.date} />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Signature<span className="text-red-500">*</span></label>
                                <div className="relative border-2 border-dashed border-gray-300 rounded-md">
                                    <SignatureCanvas
                                        ref={this.sigCanvas}
                                        penColor="black"
                                        onEnd={this.handleSignatureEnd}
                                        canvasProps={{ width: 500, height: 150, className: "rounded-md" }}
                                    />
                                    <button className='absolute bottom-[2px] right-[2px] rounded-[8px] flex items-center font-semibold w-[25px] h-[25px] p-[5px] text-[#0077B6] hover:text-[#004AAD] bg-[#CAF0F8] hover:bg-[#90E0EF] border-0' onClick={this.clearSignature}><FontAwesomeIcon icon={faEraser} /></button>
                                </div>
                                <ValidationText error={this.state.validState.error.signature} />
                            </div>
                        </div>

                        <div className="flex gap-4 mt-10">
                            <button
                                className="btn btn-success w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex items-center justify-center"
                                onClick={() => this.approveForm(this.state.submissionId)}
                                disabled={this.state.isLoading}
                            >
                                <FontAwesomeIcon icon={faCheckCircle} className="mr-3" />
                                {this.state.isLoading ? 'Approving Request...' : 'Approve Request'}
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.showPreviewModal && (
                    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center" onClick={this.closePreviewModal}>
                        <div className="bg-white rounded-lg p-4 relative shadow-xl" style={{ width: '90%', height: '90%' }} onClick={this.closePreviewModal}>
                            <button
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 px-3 py-1 rounded border-0"
                                onClick={this.closePreviewModal}
                            >
                                Close
                            </button>
                            <iframe
                                src={this.state.previewPdfUrl}
                                title="Preview Form"
                                className="w-full h-full rounded border-0"
                            />
                        </div>
                    </div>
                )}

                {this.state.showImageModal && (
                    <div
                        className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
                        onClick={this.closeImagePreview} // ⬅ closes modal on outside click
                    >
                        <div
                            className="bg-white rounded-lg p-4 relative shadow-xl max-w-3xl max-h-[90vh] overflow-auto" style={{ width: '90%', height: '90%' }}
                            onClick={(e) => e.stopPropagation()} // ⬅ prevents closing when clicking inside box
                        >
                            <button
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 px-3 py-1 rounded border-0"
                                onClick={this.closeImagePreview}
                            >
                                Close
                            </button>
                            <img
                                src={this.state.selectedImage}
                                alt="Preview"
                                className="w-full h-auto rounded"
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}